import { useToast } from "@/app/components/ui/use-toast";

interface ToastProps {
  title: string;
  description?: string;
  duration?: number;
}

const useCustomToast = () => {
  const { toast: shadToast } = useToast();

  const toast = ({ title, description, duration = 3000 }: ToastProps) => {
    shadToast({
      title,
      description,
      duration,
    });
  }

  const toastError = ({ title, description, duration = 10000 }: ToastProps) => {
    shadToast({
      title,
      description,
      duration,
      variant: "destructive",
    })
  }

  return { toast, toastError }
};

export default useCustomToast;
